import { LoyaltyParticipantTypeEnum } from 'app/models';

export class LoyaltyParticipantTypeModel {
    public static LoyaltyParticipantTypes: Array<any> = [
        { id: LoyaltyParticipantTypeEnum.TwoWheels, name: '2 Wheel Drivers' },
        { id: LoyaltyParticipantTypeEnum.FourWheels, name: '4 Wheel Drivers' }
    ];
}
